import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { HttpService } from 'src/app/service/http/http.service';
import { ShowImportDataComponent } from 'src/app/shared/popups/show-import-data/show-import-data.component';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
@Component({
  selector: 'app-competency-history',
  templateUrl: './competency-history.component.html',
  styleUrls: ['./competency-history.component.scss'],
})
export class CompetencyHistoryComponent  implements OnInit {
  loggedInUserCompanyID:any;
  importHistoryData: any = [];


  constructor(private httpService: HttpService, private loadingService: LoaderService, 
    private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog, private datePipe: DatePipe, 
    private activatedroute: ActivatedRoute,private encryptionService:EncryptionService) { }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.activatedroute.params.subscribe((params: any) => {
      this.getCompetencyHistoryData()
    })
  }

  getCompetencyHistoryData() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "search": null,
      "status": 0,
      "userType": ""
    };
  
    this.httpService.callPostService(this.config.searchImportHistoryCompetency, request)
      .subscribe((response: any) => {
        if (response && response.data && response.data.history) {
          this.importHistoryData = response.data.history; // Store the history data
        } else {
          console.log('No data found or response structure is different');
        }
      }, (error: any) => {
        console.error('Error fetching import history data:', error);
      });
  }
  

  backBtn(){
    this.router.navigate(['/home/hrportal/competency']);
  }
  
}
